import React from "react";
import { SignUp } from "../HowItWorksSections/SignUp";
import { TeamBanner } from "../OurTeamSections/TeamBanner";
import { OurInvention } from "../OurTeamSections/OurInvention";
import { TeamMembers } from "../OurTeamSections/TeamMembers";
import { TeamStory } from "../OurTeamSections/TeamStory";
import { TeamIdea } from "../OurTeamSections/TeamIdea";

import './ourTeam.scss'
const OurTeamContent = (props) => {
  return (
    <div className="ourTeam">
      <TeamBanner />
      <OurInvention />
      <TeamStory />
      <TeamIdea />
      <TeamMembers />
      <SignUp />
    </div>
  );
};
export default OurTeamContent;
